import { Printer } from "lucide-react";
import Can from "@/components/Can";
import { prettyDate } from "@/lib/format";

export function PrintButton({ testid = "print-btn", label = "Print", className = "" }) {
  return (
    <Can perm="download">
      <button type="button" data-testid={testid} onClick={() => window.print()} title="Print this page"
        className={`no-print h-9 px-3 border border-slate-300 bg-white rounded-md text-xs font-semibold uppercase tracking-wider flex items-center gap-2 hover:bg-slate-50 ${className}`}>
        <Printer size={14}/> {label}
      </button>
    </Can>
  );
}

export function PrintHeader({ company, title, subtitle }) {
  return (
    <div className="print-only mb-4 border-b-2 border-slate-900 pb-2" data-testid="print-header">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-lg font-bold">{company?.name || "LedgerFast"}</div>
          {company?.address && <div className="text-xs text-slate-600 whitespace-pre-line">{company.address}</div>}
          {(company?.phone || company?.gstin) && <div className="text-xs text-slate-600">{[company.phone, company.gstin && `GSTIN ${company.gstin}`].filter(Boolean).join(" · ")}</div>}
        </div>
        <div className="text-right">
          <div className="text-sm font-bold uppercase tracking-wider">{title}</div>
          {subtitle && <div className="text-xs text-slate-600">{subtitle}</div>}
          <div className="text-[10px] text-slate-500 mono">Printed {prettyDate(new Date().toISOString().slice(0, 10))}</div>
        </div>
      </div>
    </div>
  );
}
